import React from 'react';
import PageAuthorize from '../../../../security/PageAuthorize';
import DashboardContainer from '../../../../presentation/DashboardContainer';
import layout from './layout.json';

export default class DashboardList extends React.Component {

  constructor( props ) {
    super( props );

    this.onRenderData = this.onRenderData.bind( this );
    this.onGridFormatItem = this.onGridFormatItem.bind( this );
  }


  onRenderData( key, data ) {
    if( key === 'Ads Played By Hour' ){
      return this.onRenderAdsPlayedByHourData( data );
    } else if( key === 'Transfers By Hour' ) {
      return this.onRenderTransferByHourData( data );
    } 
    return [];
  }

  onRenderAdsPlayedByHourData( data ) {
    let rows = data[ 0 ];
    rows.map( ( row ) => {
      const newccfiledate = row.ccfiledate.toString().substring( 0,4 ) + '-' + row.ccfiledate.toString().substring( 4,6 ) + '-' + row.ccfiledate.toString().substring( 6,8 );
      row.ccfiledate = newccfiledate;
      return row;
    } );
    return rows;
  }

  onRenderTransferByHourData( data ) {
    let rows = data[ 0 ];
    rows.map( ( row ) => {
      const newccfiledate = row.ccfiledate.toString().substring( 0,4 ) + '-' + row.ccfiledate.toString().substring( 4,6 ) + '-' + row.ccfiledate.toString().substring( 6,8 );
      row.ccfiledate = newccfiledate;
      return row;
    } );
    return rows;
  }

  onGridFormatItem( key, panel, e ) {
    if( key === 'Wholesale Risk Percentages' ) {
      return this.onGridFormatItemWholesaleRiskPercentages( panel, e );
    }

    if( key === 'Wholesale Total Counts' ) {
      return this.onGridFormatItemWholesaleTotalCounts( panel, e );
    }
  }
  
  render( ) {
    return (
      <PageAuthorize groups={['Administrators','Operations','Management','Dashboards']} >
        <DashboardContainer layout={layout} onRenderData={this.onRenderData} onGridFormatItem={this.onGridFormatItem} />
      </PageAuthorize>
    );
  }
}



// WEBPACK FOOTER //
// ./src/content/dashboards/glsdirectory/components/GLSDirectoryDashboardList.js